export default __webpack_public_path__ + "static/media/logo.232b2a35.jpeg";